import { render, staticRenderFns } from "./Representante.vue?vue&type=template&id=c444c852"
import script from "./Representante.vue?vue&type=script&lang=js"
export * from "./Representante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports